module.exports = __webpack_public_path__ + "static/media/icon-x-blk.c34fc7bb.svg";